"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _semanticUiReact = require("semantic-ui-react");

var _AddToCartButton = _interopRequireDefault(require("./components/AddToCartButton"));

var _QuantitySelector = _interopRequireDefault(require("./components/QuantitySelector"));

var _VariationSelection = _interopRequireDefault(require("./components/VariationSelection"));

var _ModifierSetSelection = _interopRequireDefault(require("./components/ModifierSetSelection"));

var _SpecialInstructions = _interopRequireDefault(require("./components/SpecialInstructions"));

require("./MenuItemCartModal.css");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var MenuItemCartModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuItemCartModal, _React$Component);

  var _super = _createSuper(MenuItemCartModal);

  function MenuItemCartModal(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuItemCartModal);
    _this = _super.call(this, props);
    var variations = props.variations,
        initialSelectedVariation = props.initialSelectedVariation,
        initialSelectedModifiers = props.initialSelectedModifiers,
        initialSpecialInstructions = props.initialSpecialInstructions,
        initialQuantity = props.initialQuantity;
    _this.state = {
      selectedVariation: Object.keys(initialSelectedVariation).length > 0 ? initialSelectedVariation : variations.length === 1 ? variations[0] : {},
      selectedModifiers: initialSelectedModifiers.length > 0 ? initialSelectedModifiers : [],
      specialInstructions: initialSpecialInstructions.length > 0 ? initialSpecialInstructions : '',
      quantity: initialQuantity !== 0 ? initialQuantity : 1
    };
    _this.onSelectVariation = _this.onSelectVariation.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onSelectModifier = _this.onSelectModifier.bind((0, _assertThisInitialized2["default"])(_this));
    _this.isModifierSelected = _this.isModifierSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.isModifierDisabled = _this.isModifierDisabled.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onSpecialInstructionsChange = _this.onSpecialInstructionsChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onQuantityChange = _this.onQuantityChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onAddToCart = _this.onAddToCart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.calculateTotal = _this.calculateTotal.bind((0, _assertThisInitialized2["default"])(_this));
    _this.resetState = _this.resetState.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuItemCartModal, [{
    key: "onSelectVariation",
    value: function onSelectVariation(variationIndex) {
      var variations = this.props.variations;
      this.setState({
        selectedVariation: variations[variationIndex]
      });
    }
  }, {
    key: "onSelectModifier",
    value: function onSelectModifier(modifier, modifierSet) {
      var selectedModifiers = this.state.selectedModifiers;

      var finalModifier = _objectSpread(_objectSpread({}, modifier), {}, {
        modifierSetId: modifierSet._id
      }); // If the modifier already exists in the selection, remove it


      if (this.isModifierSelected(finalModifier._id)) {
        var indexOfModifier = selectedModifiers.map(function (_ref) {
          var _id = _ref._id;
          return _id;
        }).indexOf(finalModifier._id);
        this.setState({
          selectedModifiers: [].concat((0, _toConsumableArray2["default"])(selectedModifiers.slice(0, indexOfModifier)), (0, _toConsumableArray2["default"])(selectedModifiers.slice(indexOfModifier + 1, selectedModifiers.length)))
        });
      } else {
        this.setState({
          selectedModifiers: [].concat((0, _toConsumableArray2["default"])(selectedModifiers), [finalModifier])
        });
      }
    }
  }, {
    key: "isModifierSelected",
    value: function isModifierSelected(modifierId) {
      var selectedModifiers = this.state.selectedModifiers;
      return selectedModifiers.map(function (_ref2) {
        var _id = _ref2._id;
        return _id;
      }).includes(modifierId);
    }
  }, {
    key: "onSpecialInstructionsChange",
    value: function onSpecialInstructionsChange(e, _ref3) {
      var value = _ref3.value;
      this.setState({
        specialInstructions: value
      });
    }
  }, {
    key: "onQuantityChange",
    value: function onQuantityChange(deltaQuantity) {
      this.setState(function (_ref4) {
        var quantity = _ref4.quantity;
        return {
          quantity: quantity + deltaQuantity
        };
      });
    }
  }, {
    key: "onAddToCart",
    value: function onAddToCart() {
      var _this$props = this.props,
          cart = _this$props.cart,
          item = _this$props.item,
          onClose = _this$props.onClose,
          type = _this$props.type;
      var _this$state = this.state,
          selectedVariation = _this$state.selectedVariation,
          selectedModifiers = _this$state.selectedModifiers,
          specialInstructions = _this$state.specialInstructions,
          quantity = _this$state.quantity;
      var addItem = cart.addItem,
          updateItem = cart.updateItem,
          getItemIndex = cart.getItemIndex;

      if (type === 'add') {
        addItem(_objectSpread(_objectSpread({}, item), {}, {
          selectedVariation: selectedVariation,
          selectedModifiers: selectedModifiers,
          specialInstructions: specialInstructions,
          quantity: quantity,
          cartId: _lodash["default"].uniqueId('cart')
        }));
        this.resetState();
      } else if (type === 'update') {
        var cartItemIndex = getItemIndex(item, function (_ref5) {
          var cartId = _ref5.cartId;
          return cartId;
        });
        updateItem(_objectSpread(_objectSpread({}, item), {}, {
          selectedVariation: selectedVariation,
          selectedModifiers: selectedModifiers,
          specialInstructions: specialInstructions,
          quantity: quantity
        }), cartItemIndex);
      }

      onClose();
    }
  }, {
    key: "calculateTotal",
    value: function calculateTotal() {
      var _this$state2 = this.state,
          selectedVariation = _this$state2.selectedVariation,
          selectedModifiers = _this$state2.selectedModifiers,
          quantity = _this$state2.quantity;
      var _selectedVariation$pr = selectedVariation.price,
          variationPrice = _selectedVariation$pr === void 0 ? 0.0 : _selectedVariation$pr;
      var modifierPrices = selectedModifiers.map(function (_ref6) {
        var price = _ref6.price;
        return price;
      });
      var modifiersTotal = modifierPrices.reduce(function (total, nextPrice) {
        return total + nextPrice;
      }, 0.0);
      var total = modifiersTotal + variationPrice;
      return total * quantity;
    }
  }, {
    key: "resetState",
    value: function resetState() {
      var variations = this.props.variations;
      this.setState({
        selectedVariation: variations.length === 1 ? variations[0] : {},
        selectedModifiers: [],
        specialInstructions: '',
        quantity: 1
      });
    }
  }, {
    key: "isModifierDisabled",
    value: function isModifierDisabled(modifierSet, modifierId) {
      var selectedModifiers = this.state.selectedModifiers;
      var max_allowed = modifierSet.max_allowed,
          id = modifierSet.id;
      var selectedModifierSetModifiers = selectedModifiers.filter(function (_ref7) {
        var modifierSetId = _ref7.modifierSetId;
        return modifierSetId === id;
      }).map(function (_ref8) {
        var id = _ref8.id;
        return id;
      });
      return max_allowed > 0 && selectedModifierSetModifiers.length === max_allowed && !selectedModifierSetModifiers.includes(modifierId);
    }
  }, {
    key: "addToCartText",
    value: function addToCartText() {
      var _this$props2 = this.props,
          isOpen = _this$props2.cart.isOpen,
          type = _this$props2.type;
      if (!isOpen) return 'Ordering closed';

      if (type === 'add') {
        return 'Add to Cart';
      }

      return 'Update Item';
    }
  }, {
    key: "addToCartDisabled",
    value: function addToCartDisabled() {
      var _this$props3 = this.props,
          modifierSets = _this$props3.modifierSets,
          isOpen = _this$props3.cart.isOpen;
      var _this$state3 = this.state,
          selectedVariation = _this$state3.selectedVariation,
          selectedModifiers = _this$state3.selectedModifiers;
      var requiredModifierSets = modifierSets.filter(function (_ref9) {
        var min_allowed = _ref9.min_allowed;
        return min_allowed > 0;
      });
      var modifierSetsSatisfied = requiredModifierSets.map(function (_ref10) {
        var id = _ref10.id,
            min_allowed = _ref10.min_allowed;
        var selectedModifierSetModifiers = selectedModifiers.filter(function (_ref11) {
          var modifierSetId = _ref11.modifierSetId;
          return modifierSetId === id;
        });
        return selectedModifierSetModifiers.length >= min_allowed;
      }).every(function (val) {
        return val;
      });
      return !modifierSetsSatisfied || Object.keys(selectedVariation).length === 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          open = _this$props4.open,
          onClose = _this$props4.onClose,
          trigger = _this$props4.trigger,
          item = _this$props4.item,
          _this$props4$variatio = _this$props4.variations,
          variations = _this$props4$variatio === void 0 ? [] : _this$props4$variatio,
          modifierSets = _this$props4.modifierSets,
          modifiers = _this$props4.modifiers,
          isOpen = _this$props4.cart.isOpen;
      var _this$state4 = this.state,
          selectedVariation = _this$state4.selectedVariation,
          specialInstructions = _this$state4.specialInstructions,
          quantity = _this$state4.quantity;
      var name = item.name,
          _item$description = item.description,
          description = _item$description === void 0 ? '' : _item$description;
      description = description || '';
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal, {
        className: "item-cart-modal",
        open: open,
        onClose: onClose,
        trigger: trigger,
        dimmer: "inverted"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, null, /*#__PURE__*/_react["default"].createElement("div", null, name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "cancel",
        size: "large",
        onClick: onClose
      }))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Description, null, description && description.length > 0 && /*#__PURE__*/_react["default"].createElement("p", null, description), variations && variations.length > 1 && /*#__PURE__*/_react["default"].createElement(_VariationSelection["default"], {
        showDivider: description.length > 0,
        variations: variations,
        onSelectVariation: this.onSelectVariation,
        selectedVariation: selectedVariation,
        checkoutDisabled: !isOpen
      }), modifierSets.map(function (ms, index) {
        return /*#__PURE__*/_react["default"].createElement(_ModifierSetSelection["default"], (0, _extends2["default"])({
          key: ms.name,
          showDivider: index !== 0 || variations.length > 1 || description.length > 0,
          onSelectModifier: _this2.onSelectModifier,
          isModifierSelected: _this2.isModifierSelected,
          allModifiers: modifiers,
          modifierSets: modifierSets,
          isModifierDisabled: _this2.isModifierDisabled,
          checkoutDisabled: !isOpen
        }, ms));
      }), /*#__PURE__*/_react["default"].createElement(_SpecialInstructions["default"], {
        showDivider: variations.length > 1 || description.length > 0 || modifierSets.length > 0,
        specialInstructions: specialInstructions,
        onSpecialInstructionsChange: this.onSpecialInstructionsChange,
        checkoutDisabled: !isOpen
      }))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Actions, null, /*#__PURE__*/_react["default"].createElement(_QuantitySelector["default"], {
        onQuantityChange: this.onQuantityChange,
        quantity: quantity,
        checkoutDisabled: !isOpen
      }), /*#__PURE__*/_react["default"].createElement(_AddToCartButton["default"], {
        addToCartText: this.addToCartText(),
        checkoutDisabled: !isOpen,
        disabled: this.addToCartDisabled(),
        onAddToCart: this.onAddToCart,
        totalPrice: this.calculateTotal()
      })));
    }
  }]);
  return MenuItemCartModal;
}(_react["default"].Component);

var _default = MenuItemCartModal;
exports["default"] = _default;
MenuItemCartModal.propTypes = {
  trigger: _propTypes["default"].element,
  type: _propTypes["default"].oneOf(['add', 'update']),
  open: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  item: _propTypes["default"].object,
  modifierSets: _propTypes["default"].array,
  modifiers: _propTypes["default"].array,
  variations: _propTypes["default"].array,
  cart: _propTypes["default"].object,
  initialSelectedVariation: _propTypes["default"].object,
  initialSelectedModifiers: _propTypes["default"].array,
  initialSpecialInstructions: _propTypes["default"].string,
  initialQuantity: _propTypes["default"].number
};
MenuItemCartModal.defaultProps = {
  trigger: /*#__PURE__*/_react["default"].createElement("div", null),
  type: 'add',
  open: false,
  onClose: function onClose() {
    return null;
  },
  item: {},
  modifierSets: [],
  modifiers: [],
  variations: [],
  cart: {},
  initialSelectedVariation: {},
  initialSelectedModifiers: [],
  initialSpecialInstructions: '',
  initialQuantity: 0
};